

import { Plus, Download } from "lucide-react";

interface VendorsHeaderProps {
  isStaff: boolean;
  onExport: () => void;
  onAddVendor: () => void;
}

export function VendorsHeader({
  isStaff,
  onExport,
  onAddVendor,
}: VendorsHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-6">
      <div>
        <h1 className="text-xl font-bold text-stone-800">Vendors</h1>
        <p className="text-sm text-stone-500">Manage your vendors and their services</p>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={onExport}
          className="px-4 py-2 rounded-xl bg-stone-100 text-stone-700 font-semibold text-sm flex items-center gap-2 hover:bg-stone-200 transition-colors"
        >
          <Download className="w-4 h-4" />
          Export
        </button>
        {!isStaff && (
          <button 
            onClick={onAddVendor}
            className="px-4 py-2 rounded-xl gold-gradient text-white font-semibold text-sm flex items-center gap-2"
          >
            <Plus className="w-4 h-4" />
            Add Vendor
          </button>
        )}
      </div>
    </div>
  );
}
